var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconActions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "#F4F4F4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 21,
    height: 21,
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.125C12 7.74632 11.4963 8.25 10.875 8.25C10.2537 8.25 9.75 7.74632 9.75 7.125C9.75 6.50368 10.2537 6 10.875 6C11.4963 6 12 6.50368 12 7.125ZM12 10.5C12 11.1213 11.4963 11.625 10.875 11.625C10.2537 11.625 9.75 11.1213 9.75 10.5C9.75 9.87868 10.2537 9.375 10.875 9.375C11.4963 9.375 12 9.87868 12 10.5ZM10.875 15.0001C11.4963 15.0001 12 14.4964 12 13.8751C12 13.2537 11.4963 12.7501 10.875 12.7501C10.2537 12.7501 9.75 13.2537 9.75 13.8751C9.75 14.4964 10.2537 15.0001 10.875 15.0001Z",
    fill: "#1F273E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActions);
export default __webpack_public_path__ + "static/media/icon-actions.27a1150ddf45b6077f5d6812644a86b6.svg";
export { ForwardRef as ReactComponent };